const styles = theme => ({
  footer: {
    display: 'flex',
    flexFlow: 'column wrap',
    backgroundColor: '#FFFFFF !important'
  },
  customWidget: {
    marginLeft: '-20%'
  },

  menu: {
    fontFamily: 'Gilroy-Light',
    fontWeight: '300',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.25',
    letterSpacing: 'normal',
    color: '#3d5065',
    '& h4': {
      fontSize: '18px',
      color: '#3d5065 !important'
    },
    '& ul li a': {
      fontSize: '16px',
      color: '#778493 !important'
    }
  },
  link: {
    display: 'flex',
    flexFlow: 'column wrap',
    width: '50%'
  }
});

export default styles;

